'use client';

import { memo } from 'react';

import dayjs from 'dayjs';

import { useToggle } from '@/hooks/use-toggle';
import { WithLang } from '@/types/general';

import EventCardDesktop from './event-card.desktop';
import { EventCardProps } from './event-cards-types';

function EventCardMobile(props: WithLang<EventCardProps>) {
    const { toggleValue, handleToggle } = useToggle(true);

    //todo
    // save toggle value in session storage
    // useEffect(() => {
    //     toggleValue
    //         ? _window?.sessionStorage?.setItem(storageKeys.eventCardExpanded, props.event.id)
    //         : _window?.sessionStorage?.removeItem(storageKeys.eventCardExpanded);
    // }, [toggleValue, props.event.id]);

    const startTime = dayjs(props.event.start_date);
    const startTimeString = `${startTime.hour()}:${startTime.minute().toString().padStart(2, '0')}`;

    return (
        <div
            className={`relative overflow-hidden transition-all duration-300 ${toggleValue ? 'mb-4 max-h-[450px]' : 'max-h-[78px]'} ${props.event.status === 'past' ? 'opacity-50' : ''}`}
        >
            <div
                className="flex cursor-pointer items-center justify-between gap-x-4 rounded border-opacity-40 py-[10px] pl-2"
                onClick={handleToggle}
            >
                <p className="line-clamp-2 flex-1 pl-2 text-xl">{props.event.name}</p>
                <div className="flex flex-col gap-y-2">
                    <div className="square-button self-end border-none">
                        <span className={`icon bg-extend ${toggleValue ? 'rotate-180' : ''}`}></span>
                    </div>
                    <span className="ml-auto whitespace-nowrap text-[14px] text-gray-500">{startTimeString}</span>
                </div>
            </div>
            {/* expanded card */}
            <div
                className={`overflow-hidden rounded-md pl-4 transition-all duration-300 ${
                    toggleValue ? 'max-h-[550px]' : 'max-h-0'
                }`}
            >
                <EventCardDesktop event={props.event} lang={props.lang} />
            </div>
        </div>
    );
}

export default memo(EventCardMobile);
